import React from 'react';
import Base64ToSvg from '#web-components/components/Base64ToSvg';
import SvgUrlImage from '#web-components/components/SvgUrlImage';

export default function LoaderImage() {
  if (FTL_PARAMS?.logoLoader) {
    return <Base64ToSvg logoBase64={FTL_PARAMS.logoLoader} />;
  }
  return (
    <SvgUrlImage url={`${FTL_PARAMS.resourcesPath}/logos/loader-logo.svg`} />
  );
}
